import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

// var jobvite_apiDomain = 'https://yassonet.com/wpdev2/';
var jobvite_apiDomain = 'https://shikeb.com/';
var apiDomain = jobvite_apiDomain;
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    jobs: [],
    feedSettings: [],
    selectedcolumns: [],
    currentPage: 1
  },
  mutations: {
    SET_JOBS_TO_STATE: (state, jobs) => {
      state.jobs = jobs;
    },
    SET_FEED_SETTINGS_TO_STATE: (state, feedSettings) => {
      feedSettings.columns = feedSettings.columns.filter(function(e) {
        return e.display_frontend === 'on';
      })
      feedSettings.columns.sort(function(a, b) {
        return +a.order - +b.order;
      })
      state.feedSettings = feedSettings;
    },
    SET_CURRENT_PAGE_TO_STATE: (state, page) => {
      state.currentPage = page;
    },
  },
  actions: {
    GET_JOBS_FROM_API({commit}) {
      return axios(apiDomain+'?rest_route=/jobvite-integration/v1/get-jobfeed/', {method: 'POST'})
          .then((jobs) => {
            commit('SET_JOBS_TO_STATE', jobs.data.requisitions);
            return jobs.data.requisitions;
          })
    },
    GET_FEED_SETTINGS_FROM_API({commit}) {
      return axios(apiDomain+'?rest_route=/jobvite-integration/v1/feed-settings/', {method: 'POST'})
          .then((feedSettings) => {
           
            // console.log(feedSettings.data.columns);
             let feedData = {};
            let field = {};
            let selectedColumns = [];
            let columns =  feedSettings.data.columns.sort(function(a, b) {
              return +a.order - +b.order;
            })

      for(let column of columns) {
        if(column.display_frontend === "on") {

          let c_header = (column.label.length) ? column.label.toLowerCase() : column.name;
          let c_key = column.id == "subsidiaryname" ? "subsidiaryName" : column.id;
          
          field = { key: c_key, label: c_header.toUpperCase(), sortable: true, sortDirection: 'desc' }
          
          selectedColumns.push(field);
        }
      }

      feedData = {...feedSettings.data, selectedColumns};
      // console.log(feedData);
       commit('SET_FEED_SETTINGS_TO_STATE',feedData);
            return feedData;
          })
    },
  },
  getters: {
    JOBS(state) {
      return state.jobs;
    },
    FEED_SETTINGS(state) {
      return state.feedSettings;
    },
    CURRENT_PAGE(state) {
      return state.currentPage;
    },
  },
  modules: {
  }
})
